module.exports = __webpack_public_path__ + "img/nodata.04685b41.svg";